export default {
  'owlview.filter.action': {
    ko: "Action 조건 입력 ('%' 허용)",
    ja: "アクションの条件を入力('％'許可)",
    en: "Enter a Action... (with '%')",
    cn: '',
  },
  'owlview.services.116': {
    ko: 'NWA',
    ja: 'NWA',
    en: 'NWA',
    cn: '',
  },
  'owlview.services.112': {
    ko: 'Web Service',
    ja: 'ウェブサービス',
    en: 'Web Service',
    cn: '',
  },
  'owlview.services.110': {
    ko: 'Web Request',
    ja: 'ウェブリクエスト',
    en: 'Web Request',
    cn: '',
  },
  'owlview.java.sctn.ttl.db': {
    ko: 'DB',
    ja: 'DB',
    en: 'DB',
    cn: '',
  },
  'owlview.tasktype.117': {
    ko: 'HTTP/JSP',
    ja: 'HTTP/JSP',
    en: 'HTTP/JSP',
    cn: '',
  },
  'owlview.tasktype.118': {
    ko: 'HTTPS/JSP',
    ja: 'HTTPS/JSP',
    en: 'HTTPS/JSP',
    cn: '',
  },
  'owlview.tasktype.999': {
    ko: 'ALLE',
    ja: 'ALLE',
    en: 'ALLE',
    cn: '',
  },
  'owlview.begin': {
    ko: '시작 일시',
    ja: '開始日時',
    en: 'Begin DateTime',
    cn: '',
  },
  'owlview.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
    cn: '',
  },
  'owlview.sectionTime': {
    ko: '구간별 응답시간',
    ja: '区間別応答時間',
    en: 'R.T. devided by sections',
    cn: '',
  },
  'owlview.ip.terminal': {
    ko: 'IP [Terminal Name]',
    ja: 'IP [ターミナル名]',
    en: 'IP [Terminal Name]',
    cn: '',
  },
  'owlview.services.header.all': {
    ko: 'All Service Type',
    ja: '全てのサービスタイプ',
    en: 'All Service Type',
    cn: '',
  },
  'owlview.descendant.header.all': {
    ko: 'All Instance',
    ja: '全てのインスタンス',
    en: 'All Instance',
    cn: '',
  },
  'owlview.tasktype.19': {
    ko: 'MSADM',
    ja: 'MSADM',
    en: 'MSADM',
    cn: '',
  },
  'owlview.tasktype.18': {
    ko: 'AutoCCMS',
    ja: 'AutoCCMS',
    en: 'AutoCCMS',
    cn: '',
  },
  'owlview.tasktype.17': {
    ko: 'LICENCESRV',
    ja: 'LICENSESRV',
    en: 'LICENCESRV',
    cn: '',
  },
  'owlview.tasktype.16': {
    ko: 'AUTOJAVA',
    ja: 'AUTOJAVA',
    en: 'AUTOJAVA',
    cn: '',
  },
  'owlview.tasktype.9': {
    ko: 'NATIVE_RFC',
    ja: 'NATIVE_RFC',
    en: 'NATIVE_RFC',
    cn: '',
  },
  'owlview.tasktype.248': {
    ko: 'NR.BUFFER',
    ja: 'NR.BUFFER',
    en: 'NR.BUFFER',
    cn: '',
  },
  'owlview.tasktype.8': {
    ko: 'UPDATE2',
    ja: 'UPDATE2',
    en: 'UPDATE2',
    cn: '',
  },
  'owlview.tasktype.15': {
    ko: 'DEL.THCALL',
    ja: 'DEL.THCALL',
    en: 'DEL.THCALL',
    cn: '',
  },
  'owlview.tasktype.249': {
    ko: 'AUTO_RFC',
    ja: 'AUTO_RFC',
    en: 'AUTO_RFC',
    cn: '',
  },
  'owlview.tasktype.7': {
    ko: 'AUTOABAP',
    ja: 'AUTOABAP',
    en: 'AUTOABAP',
    cn: '',
  },
  'owlview.tasktype.14': {
    ko: 'DDLOG CLEANUP',
    ja: 'DDLOG CLEANUP',
    en: 'DDLOG CLEANUP',
    cn: '',
  },
  'owlview.tasktype.6': {
    ko: 'BUFFER SYNC.',
    ja: 'BUFFER SYNC.',
    en: 'BUFFER SYNC.',
    cn: '',
  },
  'owlview.tasktype.13': {
    ko: 'RFCVMC',
    ja: 'RFCVMC',
    en: 'RFCVMC',
    cn: '',
  },
  'owlview.filters': {
    ko: 'Filters',
    ja: 'フィルター',
    en: 'Filters',
    cn: '',
  },
  'owlview.tasktype.5': {
    ko: 'ENQUEUE',
    ja: 'エンキュー',
    en: 'ENQUEUE',
    cn: '',
  },
  'owlview.tasktype.12': {
    ko: 'RPCTH',
    ja: 'RPCTH',
    en: 'RPCTH',
    cn: '',
  },
  'owlview.tasktype.244': {
    ko: 'UI5_RFC',
    ja: 'UI5_RFC',
    en: 'UI5_RFC',
    cn: '',
  },
  'owlview.tasktype.4': {
    ko: 'BACKGROUND',
    ja: 'バックグラウンド',
    en: 'BACKGROUND',
    cn: '',
  },
  'owlview.tasktype.11': {
    ko: 'AUTOTH',
    ja: 'AUTOTH',
    en: 'AUTOTH',
    cn: '',
  },
  'owlview.tasktype.245': {
    ko: 'UI_HTTPS',
    ja: 'UI_HTTPS',
    en: 'UI_HTTPS',
    cn: '',
  },
  'owlview.filter.report.system': {
    ko: 'System 제외',
    ja: 'システム除外',
    en: 'System Excluded',
    cn: '',
  },
  'owlview.tasktype.3': {
    ko: 'SPOOL',
    ja: 'スプール',
    en: 'SPOOL',
    cn: '',
  },
  'owlview.tasktype.10': {
    ko: 'EXT.PLUGIN',
    ja: 'EXT.PLUGIN',
    en: 'EXT.PLUGIN',
    cn: '',
  },
  'owlview.tasktype.246': {
    ko: 'UI_HTTP',
    ja: 'UI_HTTP',
    en: 'UI_HTTP',
    cn: '',
  },
  'owlview.tasktype.2': {
    ko: 'UPDATE',
    ja: '更新',
    en: 'UPDATE',
    cn: '',
  },
  'owlview.tasktype.247': {
    ko: 'LONG_RUNNING_RFC',
    ja: 'LONG_RUNNING_RFC',
    en: 'LONG_RUNNING_RFC',
    cn: '',
  },
  'owlview.tasktype.1': {
    ko: 'DIALOG',
    ja: 'ダイアログ',
    en: 'DIALOG',
    cn: '',
  },
  'owlview.tasktype.0': {
    ko: 'NONE',
    ja: 'NONE',
    en: 'MOME',
    cn: '',
  },
  'owlview.show.exp.sql.warn': {
    ko: 'Expensive SQL 표시 기능을 사용하면 목록 조회에 보다 많은 시간이 소요됩니다.',
    ja: 'Expensive SQLの表示機能を使用すると、リストの照会に多くの時間がかかります。',
    en: 'It will be comsumed more time to fetch the list on using Mark Expensive SQL',
    cn: '',
  },
  'owlview.actions.header.all': {
    ko: 'All Action Type',
    ja: '全てのアクションタイプ',
    en: 'All Action Type',
    cn: '',
  },
  'owlview.java.sctn.ttl.ex': {
    ko: 'External',
    ja: '外部',
    en: 'External',
    cn: '',
  },
  'owlview.exclude.report': {
    ko: 'Exclude Report',
    ja: 'レポートを除外',
    en: 'Exclude Report',
    cn: '',
  },
  'owlview.filter.tcode': {
    ko: "T-Code 조건 입력 ('%' 허용)",
    ja: "Tコードの条件を入力('%'許可)",
    en: "Enter a T-Code... (with '%')",
    cn: '',
  },
  'owlview.tasktype.25': {
    ko: 'DAEMON',
    ja: 'DAEMON',
    en: 'DAEMON',
    cn: '',
  },
  'owlview.tasktype.24': {
    ko: 'AMC',
    ja: 'AMC',
    en: 'AMC',
    cn: '',
  },
  'owlview.tasktype.255': {
    ko: 'CPIC',
    ja: 'CPIC',
    en: 'CPIC',
    cn: '',
  },
  'owlview.tasktype.23': {
    ko: 'APC',
    ja: 'APC',
    en: 'APC',
    cn: '',
  },
  'owlview.tasktype.22': {
    ko: 'BGRFC',
    ja: 'BGRFC',
    en: 'BGRFC',
    cn: '',
  },
  'owlview.tasktype.21': {
    ko: 'BGRFCSDL',
    ja: 'BGRFCSDL',
    en: 'BGRFCSDL',
    cn: '',
  },
  'owlview.tasktype.header.all': {
    ko: 'All Task Type',
    ja: '全てのタスクタイプ',
    en: 'All Task Type',
    cn: '',
  },
  'owlview.tasktype.20': {
    ko: 'SYS_STARTUP',
    ja: 'SYS_STARTUP',
    en: 'SYS_STARTUP',
    cn: '',
  },
  'owlview.tasktype.251': {
    ko: 'WS_HTTP',
    ja: 'WS_HTTP',
    en: 'WS_HTTP',
    cn: '',
  },
  'owlview.tasktype.252': {
    ko: 'ESI',
    ja: 'ESI',
    en: 'ESI',
    cn: '',
  },
  'owlview.tasktype.253': {
    ko: 'ALE',
    ja: 'ALE',
    en: 'ALE',
    cn: '',
  },
  'owlview.tasktype.254': {
    ko: 'RFC',
    ja: 'RFC',
    en: 'RFC',
    cn: '',
  },
  'owlview.action': {
    ko: 'Action',
    ja: 'アクション',
    en: 'Action',
    cn: '',
  },
  'owlview.tasktype.250': {
    ko: 'WS_RFC',
    ja: 'WS_RFC',
    en: 'WS_RFC',
    cn: '',
  },
  'owlview.filter.report': {
    ko: "Report 조건 입력 ('%' 허용)",
    ja: "レポート条件を入力('％'許可)",
    en: "Enter a Report... (with '%')",
    cn: '',
  },
  'owlview.userId': {
    ko: '사용자 ID.',
    ja: 'ユーザーID',
    en: 'User ID.',
    cn: '',
  },
  'owlview.instance': {
    ko: '인스턴스',
    ja: 'インスタンス',
    en: 'Instance',
    cn: '',
  },
  'owlview.min': {
    ko: '최소 응답시간 (ms)',
    ja: '最小の応答時間（ms）',
    en: 'Minimal time (ms)',
    cn: '',
  },
  'owlview.tasktype.105': {
    ko: 'FTP',
    ja: 'FTP',
    en: 'FTP',
    cn: '',
  },
  'owlview.tasktype.35': {
    ko: 'B.INPUT',
    ja: 'B.INPUT',
    en: 'B.INPUT',
    cn: '',
  },
  'owlview.tasktype.108': {
    ko: 'LCOM',
    ja: 'LCOM',
    en: 'LCOM',
    cn: '',
  },
  'owlview.filter.report.owlens': {
    ko: 'OWLens 제외',
    ja: 'OWLens 除外',
    en: 'OWLens Excluded',
    cn: '',
  },
  'owlview.tasktype.34': {
    ko: 'Dialog(-)GUI',
    ja: 'Dialog(-)GUI',
    en: 'Dialog(-)GUI',
    cn: '',
  },
  'owlview.tasktype.101': {
    ko: 'HTTP',
    ja: 'HTTP',
    en: 'HTTP',
    cn: '',
  },
  'owlview.actions.101': {
    ko: 'HTTP',
    ja: 'HTTP',
    en: 'HTTP',
    cn: '',
  },
  'owlview.tasktype.102': {
    ko: 'HTTPS',
    ja: 'HTTPS',
    en: 'HTTPS',
    cn: '',
  },
  'owlview.tasktype.33': {
    ko: 'OTHERS',
    ja: 'OTHERS',
    en: 'OTHERS',
    cn: '',
  },
  'owlview.exp.sql': {
    ko: 'Expensive SQL 표시',
    ja: 'Expensive SQLを表示',
    en: 'Mark expensive SQL',
    cn: '',
  },
  'owlview.tasktype.103': {
    ko: 'NNTP',
    ja: 'NNTP',
    en: 'NNTP',
    cn: '',
  },
  'owlview.java.sctn.ttl.cpu': {
    ko: 'CPU',
    ja: 'CPU',
    en: 'CPU',
    cn: '',
  },
  'owlview.end': {
    ko: '종료 일시',
    ja: '終了日時',
    en: 'End DateTime',
    cn: '',
  },
  'owlview.tasktype.104': {
    ko: 'SMTP',
    ja: 'SMTP',
    en: 'SMTP',
    cn: '',
  },
  // Added.by.KWShin.2025.11.21.
  'owlview.actions.102': {
    ko: 'HTTPS',
    en: 'HTTPS',
  },
  'owlview.protocol': {
    ko: 'Protocol',
    ja: 'プロトコル',
    en: 'Protocol',
    cn: '',
  },
  'owlview.filter.account': {
    ko: "사용자ID 조건 입력 ('%' 허용)",
    ja: "ユーザーIDの条件を入力('％'許可)",
    en: "Enter a User ID... (with '%')",
    cn: '',
  },
  'owlview.service.type': {
    ko: 'Service type',
    ja: 'サービスタイプ',
    en: 'Service type',
    cn: '',
  },
  'owlview.filter': {
    ko: '조회조건',
    ja: '照会条件',
    en: 'Filter',
    cn: '',
  },
  'owlview.node': {
    ko: '노드',
    ja: 'ノード',
    en: 'Node',
    cn: '',
  },
  'owlview.max': {
    ko: '최대 응답시간 (ms)',
    ja: '最大の応答時間（ms）',
    en: 'Maximum time (ms)',
    cn: '',
  },
};
